<template>
    <div class="groupusers">
        <!-- 头部 -->
        <div class="top">
            <!-- 	<div class="crumbs">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item>
                            <i class="el-icon-lx-cascades"></i>
                            集团管理员
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
     -->
            <!--<div class="right">
                <span>当前集团</span>
                ：
                <el-select v-model="choosejt" placeholder="请选择集团" @change="changegroup">
                    <el-option v-for="item in AllCompanyGrouplist" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </div>-->
        </div>

        <!-- center -->
        <div class="center">
            <div class="btn" v-show='useropj.roleType < "3"'>
                <!-- <el-button type="primary" style="width: 100px;" plain @click="foraddnew('新增用户')">新增</el-button> -->
				<div class="addstyle" style="width: 100px; margin-right: 10px;"  @click="foraddnew('新增用户')">
						<samp>
				新增
						</samp>
					</div>
                <!-- <el-button type="danger" style="width: 100px;" plain @click="handleDelete()">删除</el-button> -->
				<div class="addstyle" style="width: 100px; margin-right: 10px;"  @click="handleDelete()">
						<samp>
				删除
						</samp>
					</div>
                <!-- <el-button type="primary" style="width: 100px;" plain @click="handleCommand()">导入用户</el-button> -->
				<div class="addstyle" style="width: 100px; margin-right: 10px;"  @click="handleCommand()">
						<samp>
				导入用户
						</samp>
					</div>
                <!-- <el-button type="primary"  plain  style="width: 100px;" @click="downloadDefaultTemplate">
                    下载模板
                    <i class="el-icon-download  el-icon--right"></i>
                </el-button> -->
				<div class="addstyle" style="width: 100px; margin-right: 10px;"  @click="downloadDefaultTemplate()">
						<samp>
			下载模板
			<i class="el-icon-download  el-icon--right"></i>
						</samp>
					</div>
            </div>
            <div class="search" style="width: 330px;">
                <el-input placeholder="搜索姓名、用户名、手机、邮箱" prefix-icon="el-icon-search" v-model="likeSearchvalue" clearable @input="changeserch"></el-input>
            </div>
        </div>

        <div class="table">
            <div class="tableh">
                <el-table ref="multipleTable" :data="tableData.data" style="width: 100%"  @selection-change="changeselection"  height="calc(100vh - 305px )">
                    <el-table-column type="selection"  width="55"  align="center" :selectable='selectInit'></el-table-column>
                    <el-table-column prop="userName" label="姓名"  ></el-table-column>
                    <el-table-column prop="userCode" label="用户名"  ></el-table-column>
                    <el-table-column prop="roleName" label="用户角色"  ></el-table-column>
                    <el-table-column prop="newuserType" label="角色类型"  ></el-table-column>
                    <!--				<el-table-column prop="companyName" label="所属实体"  ></el-table-column>-->
                    <!--				<el-table-column prop="companyCode" label="实体编号"  ></el-table-column>-->
                    <el-table-column prop="phone" label="手机"  ></el-table-column>
                    <el-tablebi-column prop="email" label="邮箱"  ></el-tablebi-column>
                    <el-table-column prop="state" label="用户状态"  >
                        <template slot-scope="scope">
                            <p v-if="scope.row.state === '1'">停用</p>
                            <p v-if="scope.row.state === '0'">正常</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" fixed="right" align="center">
                        <template slot-scope="scope">
                            <el-button size="text" type="primary" @click="handleCheck(scope.$index, scope.row, '查看详情')">预览</el-button>
                            <el-button v-show='controlEdit(tableData.this,scope.row)'  size="text" type="primary" @click="handleEdit(scope.$index, scope.row, '编辑详情')">编辑</el-button>


                            <!-- <el-button size="mini" type="danger" @click="handleDelete2(scope.$index, scope.row)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="buttompage">
                <el-pagination
                    class="pagination"
                    :key="elementui_page_component_key"
                    :current-page="currentpage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[50 , 100, 500]"
                    :page-size="pagenum"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalcount"
                ></el-pagination>
            </div>

            <!-- 弹层 -->
            <!-- 添加弹层 -->
            <el-dialog :title="title" class="dialog"  :visible.sync="dialogVisible2" width="800px" :close-on-click-modal="false" >
                <!-- <minhead :Stringtitle="title" :isdiag="true"></minhead> -->
                <div  class="form">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="姓名" prop="userName"><el-input v-model="ruleForm.userName" :disabled="title == '查看详情'"></el-input></el-form-item>
                        <el-form-item label="手机号" prop="phone"><el-input v-model="ruleForm.phone" :disabled="title == '查看详情'"></el-input></el-form-item>
                        <el-form-item label="用户名" prop="userCode"><el-input v-model="ruleForm.userCode" :disabled="title == '查看详情'"></el-input></el-form-item>
                        <el-form-item prop="email" label="邮箱"><el-input v-model="ruleForm.email" :disabled="title == '查看详情'"></el-input></el-form-item>

                        <!--						<el-form-item style="margin-bottom: 30px;" label="密码" prop="password"  v-show="false">-->
                        <!--							<el-input type="password" :disabled="title == '查看详情'" v-model="ruleForm.password" auto-complete="off"></el-input>-->
                        <!--						</el-form-item>-->
                        <!--						<el-form-item label="确认密码" prop="checkPass" v-show="false">-->
                        <!--							<el-input type="password" v-model="ruleForm.checkPass" auto-complete="off"></el-input>-->
                        <!--						</el-form-item>-->
                        <el-form-item label="用户类型" prop="userType" v-show="false">
                            <el-select v-model="username"  placeholder="集团管理员" >
                                <el-option v-for="item in useralllist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="集团名称" v-show="false"><el-input v-model="ruleForm.companyGroupName"   ></el-input></el-form-item>
                        <el-form-item label="用户角色" prop="userType">
                            <el-select v-model="ruleForm.roleId" placeholder="请选择"  style="width: 100%;"  :disabled="title == '查看详情'">
                                <el-option
                                    v-for="item in roleComboData"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态" prop="state" >
                            <el-select v-model="ruleForm.state" :disabled="title == '查看详情'">
                                <el-option label="停用" value="1"></el-option>
                                <el-option label="正常" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <div style="padding-left: 15px;width:100%">
                            <span class="ar-title">关联实体信息</span>
                            <div style="padding-top: 10px;" v-if="showCompanyOpBtn()">
                                <el-button plain style="width: 80px;" @click="addRelCompanyClickFun()">添加</el-button>
                                <el-button plain style="width: 80px;" @click="delRelCompanyClickFun()">删除</el-button>
                            </div>
                            <div style="padding-top: 10px;width:100%">
                                <el-table :data="ruleFormcompanyList" border stripe  width="100%" height="250px" class="table" ref="relCompanyTable" @row-click="clickUserRelCompanyRowByChecked">
                                    <el-table-column type="selection" width="55" align="center" label="序号"></el-table-column>
                                    <el-table-column prop="id" v-if="showColumn"></el-table-column>
                                    <el-table-column prop="name" label="实体名称"  show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="taxNumber" label="实体税号"  show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="qiybh" label="实体代码"  show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="state" label="当前状态" :formatter="stateFormat"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-form>
<div slot="footer" style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="submitForm('ruleForm')" v-if="title != '查看详情'" >保存</div>
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="returnForm2()">返回</div>
			</div>
               <!--     <div class="buttomanniu">
                        <el-button  type="primary" @click="submitForm('ruleForm')" v-if="title != '查看详情'">保存</el-button>
                        <el-button  @click="returnForm2()">返回</el-button>
                    </div> -->

                    <!-- <el-button @click="resetForm('ruleForm')">重置</el-button>  -->
                </div>
            </el-dialog>

            <!-- 关联实体信息 - 实体信息显示 -->
            <el-dialog title="公司信息" :visible.sync="showCompanyDataDialogVisible" width="600px" :close-on-click-modal="false" v-dialogDrag class="dialog" >
                <!-- <minhead :Stringtitle="'公司信息'" :isdiag="true"></minhead> -->
                <div class="custom-dialog">
                    <div style='width: 200px;'><el-input v-model="searchCompanyName" @input='changeSearchValue' placeholder="请输入实体名称"></el-input></div>
                    <div style="padding-top: 10px;">
                        <el-table :data="filterCompanyList" border stripe height="300px" class="table" ref="companyTable" @row-click="clickCompanyTableRowByChecked">
                            <el-table-column width="55" align="center">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.selection" @change="changeCompanyCheck(scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" v-if="showColumn"></el-table-column>
                            <el-table-column prop="name" label="实体名称"  show-overflow-tooltip></el-table-column>
                            <el-table-column prop="taxNumber" label="实体税号"  show-overflow-tooltip></el-table-column>
                            <el-table-column prop="qiybh" label="实体代码"  show-overflow-tooltip></el-table-column>
                            <el-table-column prop="state" label="当前状态" :formatter="stateFormat"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div  class="buttomanniu">
                    <el-button @click="clickCompanyTableRowByChecked(null,true)" >全选</el-button>
                    <el-button @click="clickCompanyTableRowByChecked(null,false)" >全不选</el-button>
                    <el-button type="primary" @click="saveUserRelCompanyClickFun()" >保存</el-button>
                    <el-button @click="showCompanyDataDialogVisible = false" >返回</el-button>
                </div>
            </el-dialog>
            <el-dialog title="选择文件" :visible.sync="daorudiag" width="700px" :close-on-click-modal="false" append-to-body v-dialogDrag>
                <!-- <minhead :headtitle="daorutitle" :isdiag="true"></minhead> -->
                <div class="Verticalcenter" style="margin-top: 82px;">
                    <div class="Centerhorizontally" style="margin-left: 260px;">
                        <el-input style="width: 300px;margin-right: 16px;" disabled v-model="upfilename"></el-input>

                        <label style="display: flex;align-items: center;">
                            <div class="Centerhorizontally bt1">选择文件</div>
                            <input type="file" class="sendinput" @change="uploadFile($event)" :value="filestate" />
                        </label>
                    </div>
<div slot="footer" style="justify-content: center; display: flex;margin-top: 30px;">
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="sureupload"  >确定</div>
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="daorudiag = false">关闭</div>
			</div>
                   <!-- <div class="buttomanniu">
                        <el-button type="primary" @click="sureupload">确定</el-button>
                        <el-button  @click="daorudiag = false">关闭</el-button>
                    </div> -->
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/;
            if(value==''||value=='********'){
                callback();
            } else 	if (!reg.test(value)) {
                callback(new Error('密码需包含大小写字母、数字且大于8位'));
            } else {
                callback();
            }
        };
        var verifPassword = (rule, value, callback) => {

            if (!reg.test(value)) {
                callback(new Error('只能输入数字'));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if(value == ''&&this.ruleForm.password==''){
                callback();
            } else if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value != this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var validateTel = (rule, value, callback) => {
            if(value!='') {
                const reg = /^[1][3,4,5,6,7,8][0-9]{9}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error('请输入正确的手机号'));
                }
            }else{
                callback();
            }
        };
        return {
            useropj:{},
            glytitle:['系统设置', '人员管理'],
            daorudiag: false,
            daorutitle: ['选择文件'],
            likeSearchvalue: '',
            title: '查看详情',
            rules: {
                userName: [{ required: true, message: '请输入名字', trigger: 'blur' }, { trigger: 'blur' }],
                phone: [{ validator:validateTel,  trigger: 'blur' }],
                userCode: [{ required: true, message: '请输入用户名', trigger: 'blur' }, { trigger: 'blur' }],
                //password: [{validator: validatePass, trigger: 'blur' }],
                email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
                checkPass: [{validator: validatePass2, trigger: 'blur' }]
            },
            ruleForm: {
                userName: '',
                phone: '',
                userCode: '',
                email: '',
                password: '',
                checkPass: '',
                state:'0',
                userType: '',
                companyGroupName: '',
                companyGroupId: '',
                version:'',
                roleId:'',
                companyIds:'',
                companyList: []
            },
            choosejt: '所有',
            choosejtid: '',
            /* 可建人员类型	 */
            username: '一般用户',
            userType: '3',
            useralllist: [
                {
                    label: '超级管理员',
                    value: '0'
                },
                {
                    label: '集团管理员',
                    value: '1'
                },
                {
                    label: '实体管理员',
                    value: '2'
                },{
                    label: '一般用户',
                    value: '3'
                }
            ],

            input21: '',
            dialogVisible2: false,
            dialogVisible3: false,

            AllCompanyGrouplist: [],

            //table数据
            tableData: {
                data:[],
                this:this
            },
            ids: '',
            totalcount:"",
            page:1,
            pagenum:50,
            userRelCompanyData: [],
            showCompanyDataDialogVisible: false,
            currGroupData: '',  //  当前集团信息
            allCompanyList: '', //  当前集团下所有实体信息
            disabled: false,    //  字段是否禁用
            disabledUserCode: false,    //  用户名是否禁用
            showRelCompanyOpBtn:false,
            showCompanyOpBtn(){
                // 关联实体的“添加”和“删除”只有集团管理员账号可以操作
                if (JSON.parse(localStorage.getItem("useropj")).userType != '1' && JSON.parse(localStorage.getItem("useropj")).userType != '0'){
                    return false
                }
                return this.showRelCompanyOpBtn;
            },
            showColumn:false,  //id列是否隐藏
            roleComboData: [],
            upfilename:"",
            filestate:"",
            upfile:"",
            ruleFormcompanyList:[],
            tableHeight:"",
            currentpage:1,
            elementui_page_component_key:"",
            searchCompanyName:"",
            primaryFilterCompanyList:[],
            filterCompanyList:[],
        };
    },
    mounted() {
        this.$nextTick(() =>{
            this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
            window.onresize = () =>{
                this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
            }
        })
    },
    created() {
        this.useropj = JSON.parse(localStorage.getItem('useropj'));
        this.choosejt = this.useropj.currCompany.companyGroup.name;//获取当前集团名称
        this.choosejtid = this.useropj.currCompany.companyGroup.id;//获取当前集团id
        this.ruleForm.companyGroupName=this.useropj.currCompany.companyGroup.name;//获取当前集团名称
        this.ruleForm.companyGroupId=this.useropj.currCompany.companyGroup.id;//获取当前集团id
        this.getUserList();
    },
    methods: {
        controlEdit(thisData, rowData) {
            //超级管理员有所有权限
            if (thisData.useropj.userType == "0") {
                return true;
            } else if(rowData.userType != "0"){
                if(thisData.useropj.roleType < rowData.roleType){
                    return true;
                }
            }

            return false;
        },
        changeSearchValue(e){
            this.filterCompanyList = this.allCompanyList.filter(item => item.name.indexOf(e) > -1);
            let ids = this.filterCompanyList.filter(item => item.id);
            this.allCompanyList.forEach(item => {
                if (item.selection && ids.indexOf(item.id) == -1) {
                    this.filterCompanyList.push(item);
                }
            });
        },
        selectInit(row,index){
            //超级管理员无法删除
            if(row.roleType == "0"){
                return false;
            }
            return row.roleType !== "1";
        },
        /* 搜索 */
        changeserch(e) {
            this.currentpage=1
            this.elementui_page_component_key++
            this.page=1
            this.likeSearchvalue = e;
            this.getUserList();
        },
        /* 	选择人员类型 */
        choosemembertype(e) {
            this.userType = e;
        },
        /* 选择集团 */
        /*changegroup(e) {
            this.AllCompanyGrouplist.forEach(item => {
                if (item.id == e) {
                    this.choosejt = item.name;
                    this.choosejtid = item.id;
                    this.ruleForm.companyGroupName = item.name;
                    this.ruleForm.companyGroupId = item.id;
                }
            });
            this.getUserList();
        },*/
        /* 查看弹框弹出*/
        handleCheck(index, row, title) {
            this.title = title;
            this.$nextTick(() => {
                this.$refs['ruleForm'].clearValidate();
            });
            this.getUserById(row.id);
            this.showRelCompanyOpBtn=false;
            this.ruleFormcompanyList=[];
            this.getCompanyDataByCurrGroupId(row.companyGroupId);
            this.getRoleListByGroupId(true);
            this.getUserAndCompanyMapping(row.id);
            console.log(this.ruleForm);
        },
        /* 编辑弹框弹出 */
        handleEdit(index, row, title) {
            if (this.$refs['ruleForm']){
                this.$nextTick(() => {
                    this.$refs['ruleForm'].clearValidate();
                });
            }
            this.title = title;
            this.showRelCompanyOpBtn=true;
            this.ruleFormcompanyList=[];
            this.getUserById(row.id, 'update');
            this.getCompanyDataByCurrGroupId(row.companyGroupId);
            this.getRoleListByGroupId();
            this.getUserAndCompanyMapping(row.id);
        },
        /* 	新增用户弹出*/
        foraddnew(title) {
            if (this.choosejtid == '') {
                this.$message.error(this.$tolertJSON[4000]);
                return false;
            }
            if (!this.choosejtid){
                this.$message.error(this.$tolertJSON["ISJTNULL"]);
                return false;
            }
            this.$nextTick(() => {
                this.$refs['ruleForm'].clearValidate();

            });
            this.dialogVisible2 = true;
            this.title = title;
            this.showRelCompanyOpBtn=true;

            this.getCompanyDataByCurrGroupId(this.choosejtid);
            this.getRoleListByGroupId();
            Object.keys(this.ruleForm).map(key => ((this.ruleForm[key] = ''), (this.ruleForm['companyGroupName'] = this.choosejt), (this.ruleForm['companyGroupId'] = this.choosejt)));
            this.ruleFormcompanyList=[this.useropj.currCompany];    // 新增用户默认关联当前实体
            this.ruleForm.state = '0';
        },

        /* 用户保存，编辑 */
        submitForm(formName) {
            this.ruleForm.checkPass=this.ruleForm.checkPass.replace("********","");
            this.ruleForm.password=this.ruleForm.password.replace("********","");
            if (this.ruleFormcompanyList.length == 0){
                this.$message.error("至少关联一个实体");
                return;
            }
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.title == '新增用户') {
                        this.addUser();
                    } else if (this.title == '编辑详情') {
                        this.updateUser();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleSizeChange(val) {
            this.pagenum=val
            this.getUserList()
        },
        handleCurrentChange(val) {
            this.page=val
            this.getUserList()
        },
        /* 返回 */
        returnForm2() {
            this.dialogVisible2 = false;
        },

        /* 多选 */
        changeselection(e) {
            this.ids = '';
            e.forEach((item, index) => {
                this.ids = this.ids + item.id + ',';
            });
            var reg = /,$/gi;
            this.ids = this.ids.replace(reg, '');
        },
        /* 多个删除 */
        /* 单个删除 */
        handleDelete() {
            this.$confirm('是否确认将删除用户?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (this.ids == '') {
                        this.$message({
                            type: 'info',
                            message: '请选择要删除的元素'
                        });
                    } else {
                        this.deleteUsers(this.ids);
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },

        // handleDelete2(index, row) {
        // 	let id = row.id;
        // 	this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        // 		confirmButtonText: '确定',
        // 		cancelButtonText: '取消',
        // 		type: 'warning'
        // 	})
        // 		.then(() => {
        // 			this.deleteUser(id);
        // 		})
        // 		.catch(() => {
        // 			this.$message({
        // 				type: 'info',
        // 				message: '已取消删除'
        // 			});
        // 		});
        // },


        /* 	接口调用操作 */



        /* 	查看用户 */
        getUserById(id, f) {
            let params = id;
            this.$https.fetchPost('sys/admin/getUserById', params).then(res => {
                this.ruleForm=[];
                res.data.obj.checkPass='********';
                res.data.obj.password='********';
                if (!res.data.obj.roleId){
                    res.data.obj.roleId = 0;
                }
                this.ruleForm=res.data.obj;
            });
        },
        /* 	获取集团下用户列表 */
        getUserList() {
            if(this.choosejtid==""){
                this.choosejtid=null
            }
            let search={}
            if(this.choosejtid==""||this.choosejtid==null){
                // search={userType:"2,3"}
            }else{
                search={groupId:this.choosejtid}
            }
            let params = {

                search: search,
                likeSearch: this.likeSearchvalue,
                page: this.page,
                limit: this.pagenum
            };
            this.$https.fetchPost('sys/admin/getUserList', params).then(res => {
                this.totalcount=res.data.count
                this.tableData.data = res.data.data;
                this.tableData.data.forEach(item => {
                    item.newuserType = this.typetostring(item.userType);
                });
            });
        },
        /* 	新增用户 */
        addUser() {
            let params = {};
            params = this.ruleForm;
            params.companyIds = "";
            this.ruleForm.companyGroupId = this.choosejtid;
            this.ruleForm.companyGroupName = this.choosejt;
            if(!this.ruleFormcompanyList||this.ruleFormcompanyList.length==0){
                this.$message.error("请选择关联实体信息。");
                return;
            }
            if (this.ruleFormcompanyList){
                for (let i=0;i<this.ruleFormcompanyList.length;i++){
                    if(this.ruleFormcompanyList[i].id){
                        params.companyIds+=this.ruleFormcompanyList[i].id+",";
                    }
                }
            }
            params.userType = this.userType;
            params.companyList=this.companyList
            this.$https.fetchPost('sys/admin/saveUser', params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.dialogVisible2 = false;
                }
            });
        },
        /* 批量删除用户 */
        deleteUsers(ids) {
            let params = ids;
            this.$https.fetchPost('sys/admin/deleteUsersByType', params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.$message.success(this.$tolertJSON[4004]);
                    this.dialogVisible2 = false;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        /* 删除用户 */
        deleteUser(id) {
            let params = id;
            this.$https.fetchPost('sys/admin/deleteUser', params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.$message.success(this.$tolertJSON[4003]);
                    this.dialogVisible2 = false;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        /* 更新用户 */
        updateUser() {
            let params = {};
            params = this.ruleForm;
            params.companyIds="";
            if(!this.ruleFormcompanyList||this.ruleFormcompanyList.length==0){
                this.$message.error("请选择关联实体信息。");
                return;
            }
            for (let i=0;i<this.ruleFormcompanyList.length;i++){
                params.companyIds+=this.ruleFormcompanyList[i].id+",";
            }
            params.companyList=this.companyList

            //params.userType = this.userType;
            this.$https.fetchPost('sys/admin/updatePasswordHashUser', params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.dialogVisible2 = false;
                }
            });
        },
        getRoleListByGroupId(preview) { //  获取当前集团下的所有用户角色数据
            this.$https.fetchPost('/sys/admin/getRoleListByCompany').then(res => {
                if(res.data.success) {
                    this.assembleRoleComboData(res.data.obj).then(()=>{
                            if (preview && this.ruleForm.roleId){
                                console.log("preview")
                                this.roleComboData.push({value: this.ruleForm.roleId, label: this.getRoleLabel({roleType:this.ruleForm.roleType,roleName:this.ruleForm.roleName})})
                            }
                        }
                    );
                } else {
                    this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
                }
            }, error => {
                this.$message.error('加载当前集团下用户角色信息错误：' + error);
            });
        },
        async assembleRoleComboData(roleData) {   //  拼接用户角色下拉数据
            let roleComboData = [{value: 0, label: '无角色权限'}];
            if(roleData && roleData.length > 0) {
                roleData.forEach(role => {
                    roleComboData.push({value: role.id, label: this.getRoleLabel(role)});
                });
            }
            this.roleComboData = roleComboData;
        },
        // 获取显示在页面上的用户类型
        getRoleLabel(role){
            let prefix = ''
            if (role.roleType == '1'){
                prefix = '集团管理员-'
            }
            if (role.roleType == '2'){
                prefix = '实体管理员-'
            }
            if (role.roleType == '3'){
                prefix = '一般用户-'
            }
            return prefix + role.roleName;
        },
        addRelCompanyClickFun() {   //  新增用户关联公司信息
            this.showCompanyDataDialogVisible = true;
            for (let i=0;i<this.ruleFormcompanyList.length;i++){
                for (let k=0;k<this.allCompanyList.length;k++){
                    if (this.ruleFormcompanyList[i].id==this.allCompanyList[k].id) {
                        this.allCompanyList.splice(k, 1);
                    }
                }
            }
            //过滤掉已经选择的公司
            let filteredList = this.primaryFilterCompanyList.filter(obj1 => !this.ruleFormcompanyList.some(obj2 => obj1.id === obj2.id));  
            this.filterCompanyList = filteredList;
            this.ruleFormcompanyList.push({});
            this.ruleFormcompanyList.pop({});
        },
        delRelCompanyClickFun() {   //  删除用户关联公司信息
            let checkRows = this.$refs.relCompanyTable.selection;
            if(!checkRows || checkRows.length == 0) {
                this.$message.warning('请选择需要删除关联的公司信息！');
                return;
            }
            //数据返回到列表中
            for (let i=0;i<checkRows.length;i++){
                this.allCompanyList = this.allCompanyList.concat(checkRows[i]);
            }
            //删除被选中的公司
            for (let i=0;i<checkRows.length;i++){
                for (let k=0;k<this.ruleFormcompanyList.length;k++){
                    if (this.ruleFormcompanyList[k].id==checkRows[i].id) {
                        this.ruleFormcompanyList.splice(k, 1);
                    }
                }
            }
            this.ruleFormcompanyList.push({});
            this.ruleFormcompanyList.pop({});
        },
        changeCompanyCheck(row) {
            this.clickCompanyTableRowByChecked(row);
        },
        clickCompanyTableRowByChecked(row,flag) {
            // this.$refs.companyTable.toggleRowSelection(row);
            if(!row){
                this.filterCompanyList.forEach(item => {
                         item.selection = flag;
                    
                })
                this.allCompanyList.forEach(item => {
                         item.selection = flag;
                    
                })
            }else{

            
            if (row.selection) {
                row.selection = false;
                this.allCompanyList.forEach(item => {
                    if (item.id == row.id) {
                        item.selection = false;
                    }
                })
            } else {
                row.selection = true;
                this.allCompanyList.forEach(item => {
                    if (item.id == row.id) {
                        item.selection = true;
                    }
                })
            }
        }
            let data = JSON.parse(JSON.stringify(this.filterCompanyList));
            this.filterCompanyList = data;
        },
        clickUserRelCompanyRowByChecked(row) {
            this.$refs.relCompanyTable.toggleRowSelection(row);
        },
        saveUserRelCompanyClickFun() {  //  保存用户勾选的公司信息
            if (!this.ruleFormcompanyList){
                this.ruleFormcompanyList=[];
            }
            let checkRows = this.allCompanyList.filter(item => item.selection == true);
            if(!checkRows || checkRows.length == 0) {
                this.$message.warning('请选择需要关联的公司信息！');
                return;
            }
            //显示用户勾选的列表
            for (let i=0;i<checkRows.length;i++){
                this.ruleFormcompanyList = this.ruleFormcompanyList.concat(checkRows[i]);
            }
            //删除存在对象
            for (let i=0;i<checkRows.length;i++){
                for (let k=0;k<this.allCompanyList.length;k++){
                    if (this.allCompanyList[k].id==checkRows[i].id) {
                        this.allCompanyList.splice(k, 1);
                    }
                }
            }
            this.showCompanyDataDialogVisible = false;
        },
        getCompanyDataByCurrGroupId(groupId) { //  用户勾选关联公司：company data
            this.$https.fetchPost('/sys/admin/getCompanyListByGroup', groupId).then(res => {
                if(res.data.success) {
                    this.allCompanyList = JSON.parse(JSON.stringify(res.data.obj));
                    this.primaryFilterCompanyList = JSON.parse(JSON.stringify(res.data.obj));
                    this.filterCompanyList = JSON.parse(JSON.stringify(res.data.obj));
                    this.allCompanyList.forEach(item => item.selection = false);
                    this.filterCompanyList.forEach(item => item.selection = false);
                } else {res.data.data;
                    this.$message.error('获取当前集团下所有实体信息失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('获取当前集团下所有实体信息失败：' + error);
            });
        },
        getUserAndCompanyMapping(groupId) { //  获取用户已勾选的公司
            this.$https.fetchPost('/sys/admin/getUserAndCompanyMapping', groupId).then(res => {
                if(res.data.success) {
                    this.ruleFormcompanyList=res.data.obj
                    this.dialogVisible2 = true;
                    // var newform=JSON.parse(JSON.stringify(this.ruleForm))
                    // newform.companyList=res.data.obj
                    // this.ruleForm=[]
                    // this.ruleForm=newform
                    // console.log(this.ruleFormcompanyList)


                } else {
                    this.$message.error('获取当前用户下所有实体信息失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('获取当前用户下所有实体信息失败：' + error);
            });
        },
        stateFormat(row, column, cellValue, index) {
            if (row.state == "0") {
                return "正常";
            } else if (row.state == "1") {
                return "停用";
            }else{
                return row.state;
            }
        },
        uploadFile($event) {
            this.upfilename=$event.target.files[0].name
            var reader = new FileReader();
            let fileData =$event.target.files[0]
            let formData = new FormData();

            formData.append('id', this.id)

            formData.append('uploadFile', fileData);
            this.upfile=formData

        },
        sureupload(){
            if(this.upfile==""){
                this.$message.error('请选择文件！');
                return;
            }
            this.uploadExcel(this.upfile)
        },
        handleCommand(e){
            this.filestate=""
            this.upfilename=""
            this.upfile=""
            this.daorudiag=true
        },
        /* 上传 */
        uploadExcel(upfile) {
            let params =upfile
            this.$https.fetchPost('sys/userImport/uploadUserExcel', params).then(res => {
                if(res.data.success){
                    this.getUserList();
                    this.daorudiag=false

                }

            })
        },
        /* 接口调用操作 */
        downloadDefaultTemplate() {
            location.href=this.$https.baseURL+"sys/userImport/downloadDefaultTemplate"
        },
    }
};
</script>

<style scoped lang="less">
.form{
    margin-right: 30px;
}
/deep/.el-table--small td {
    padding: 4px 0;
}
/deep/.el-table__body-wrapper {
    min-height: 200px;
}
.btn {
    display: flex;
    margin-top: 16px;
    margin-bottom: 16px;
}
.pagination {
    margin-top: 15px;
}
.bottombut {
    margin-top: 20px;

    display: flex;
    justify-content: flex-end;
}
.groupusers {
    padding:0 10px;
}

.top {

}
.center {
    display: flex;
    justify-content: space-between;
}
.center .btn {
    margin-bottom: 16px;
}
.search{
    margin-top: 16px;
}

.el-form {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 50%;
}
.sendinput {
    visibility: hidden;
}
.bt1 {
    width: 80px;
    height: 31px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    color: #2f66fc;
}
.areatable {
    margin-top: 27px;
}
.areacontent {
    margin-left: 21px;
}
</style>
